import { z } from 'zod'
import config from 'src/config'
import { get, post } from 'src/functions/fetch'
import { newsletterFrequencySchema, newsletterInterestsSchema, type NewsletterSubscription } from 'src/shared/newsletter'

const subscriptionSchema = z.object({
  email: z.string(),
  status: z.enum(['not_subscribed', 'pending', 'subscribed', 'unsubscribed', 'suppressed']),
  interests: newsletterInterestsSchema,
  frequency: newsletterFrequencySchema,
})

export function readSubscription(value: unknown): NewsletterSubscription {
  const parsed = subscriptionSchema.safeParse(value)
  if (!parsed.success) throw new Error('Die Newsletter-Einstellungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.')
  return parsed.data
}

export async function getNewsletterAvailability(signal?: AbortSignal): Promise<boolean> {
  const response = await get({ url: `newsletter/status?shopId=${config.shop.shop}`, signal })
  const parsed = z.object({ available: z.boolean() }).safeParse(response)
  if (!parsed.success) throw new Error('Die Newsletter-Anmeldung ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.')
  return parsed.data.available
}

export async function newsletterRequest(path: string, body: Record<string, unknown>, signal?: AbortSignal): Promise<Record<string, unknown>> {
  const response = await post({ url: `newsletter/${path}`, body: { ...body, shopId: config.shop.shop }, signal })
  if (!response || typeof response !== 'object' || ('ok' in response && response.ok === false) || 'error' in response) {
    const message = response && typeof response === 'object' && 'message' in response && typeof response.message === 'string'
      ? response.message : response && typeof response === 'object' && 'error' in response && typeof response.error === 'string'
        ? response.error : 'Das hat gerade nicht geklappt. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Service.'
    throw new Error(message)
  }
  return response as Record<string, unknown>
}
